<template>
  <!-- 短信自助充值组件 -->
  <div>
    <x-popup :isShow="isShow" width="450px" top='15vh' title='充值' @cencal="fCancalPopupShow" :appendToBody='true'>
      <div class="x-text-c">
        <div class='x-p-t-20 x-font-20'>{{params.msg}}</div>
        <div class='x-p-t-10 f600 x-font-20' style="color: #FF5E44;">￥{{api.numHelper.fMoneyFat(params.money)}}</div>
        <div class='x-p-t-10 x-flex x-row-center'>
          <div class="x-w200 x-h200 x-bd x-bd-ra x-flex x-row-center">
            <div id="qrcodeMax" ref="qrCodeUrlMax"></div>
          </div>
        </div>
        <div class='x-p-t-20'>扫一扫立即付款</div>
        <div class='x-p-t-10 x-p-b-50' style="color: #FF3939;">温馨提示：扫码后请勿关闭当前界面，等待提示充值完成</div>
      </div>
    </x-popup>
  </div>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    props: {
      // 是否显示
      isShow: {
        type: [String, Boolean],
        default: false,
      },
      type: {
        type: [String, Boolean],
        default: false,
      },
      params: [Array, Object],
      default: () => {
        return []
      },
    },
    data() {
      return {
        active: '', //选中方案
        mallInfo: [],
        payQrPop: false,
        // payUrl: ''
        timer: null
      }
    },
    watch: {
      isShow(newVal) {
        if (newVal) {
          this.init()
        }
      }
    },
    mounted() {
      // this.fCreateQRcode()
    },
    methods: {
      async init(newVal) {
        let res = await this.fPartnerSkZhManger()
        if (res.result != 'sucess') {
          return this.$message(res.msg)
        }
        // this.payUrl = res.pay_url
        this.fCreateQRcode(res.pay_url)

        this.timer = setInterval(async () => {
          // if (time == 0) {
          let resPay = await this.fSmPayQuery(res.app_id, res.app_mall_id, res.app_secret, res.ord_no, res
            .sm_pay_url)
          if (resPay.result != 'sucess') {
            if (resPay.msg != 'PAYING') {
              clearInterval(this.timer)
              return this.$message(resPay.msg)
            }
            return
          }
          this.fCancalPopupShow('sucess')
          // }
        }, 10000)

      },
      // 生成二维码
      async fCreateQRcode(url) {
        // this.isShowQr = true
        document.getElementById("qrcodeMax").innerHTML = "";
        let text = url
        new QRCode(this.$refs.qrCodeUrlMax, {
          text, // 需要转换为二维码的内容
          width: 180,
          height: 180,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      },
      //关闭弹窗
      fCancalPopupShow(type) {
        clearInterval(this.timer)
        if (type == 'sucess' && this.type == 'smSellSmsCz') {
          this.$emit("cencal", {
            sucess_msg: '短信充值成功',
            sucess_num: this.params.num + '条'
          });
          return
        }
        if (type == 'sucess' && this.type == 'smSellNfMoney') {
          this.$emit("cencal", {
            sucess_msg: '数据存储空间续费成功',
          });
          return
        }
        if (type == 'sucess' && this.type == 'smSellOpenECard') {
          this.$emit("cencal", {
            sucess_msg: '升级成功',
          });
          return
        }
        this.$emit("cencal");
      },
      //请求开始==================================

      // 获取合作伙伴支付宝收款账户
      async fPartnerSkZhManger(oper) {
        // GROUP_LIST SUB_PRO_LIST
        let js = {};
        js['PARTNER_PHONE'] = "18957102098" //this.$store.state.smSellAdmin.partnerPhone;
        js['TOTAL_AMOUNT'] = this.params.money
        js['ORDER_TYPE'] = this.type //
        if (this.type == 'smSellNfMoney') {
          js['APP_BB'] = this.params.bb //
        }
        js['SMSELL_MCH_PHONE'] = this.$store.state.smSellAdmin.shPhone
        js['SMSELL_MALL_ID'] = this.$store.state.smSellAdmin.shMallId
        js['SMSELL_OPER_VALUE'] = this.params.num //

        let res = await this.api.smSellApi.fPostToSmSellMainSrvApi('SMSELL_MCHSELF_PAY_2D', js)
        return res;
      },

      // SMPAY扫码支付

      // SMPAY支付查询接口
      async fSmPayQuery(app_id, app_mall_id, app_secret, ord_no, sm_pay_url) {
        let js = {};
        js['MCH_ID'] = app_id;
        js['STORE_ID'] = app_mall_id;
        js['STORE_SALESMAN_ID'] = app_id;
        js['ORD_NO'] = ord_no;
        js['APP_ID'] = app_id;
        js['APP_MALL_ID'] = app_mall_id;
        js['APP_SECRET'] = app_secret;
        let res = await this.api.smSellApi.fPostToSmPayAggApi('AGGPAY_TRADE_QUERY', js, sm_pay_url, app_id,
          app_secret)
        return res
      },


      // 请求结束================================
    }
  }
</script>

<style lang="less" scoped="scoped">
  /deep/.el-input__icon {
    line-height: unset;
  }

  .active {
    color: #6396FC;
    border-color: #6396FC;
  }
</style>



// WEBPACK FOOTER //
// src/components/smRecharge.vue